import { resolveMediaUrl } from './mediaUrl';

const getSection = (page, key) => page?.sections?.find((section) => section.key === key) || null;

const getMediaUrl = (section, groupKey) => {
  const media =
    section?.media?.groups?.[groupKey]?.[0] ||
    (groupKey === 'hero-image' || groupKey === 'feature-image' ? section?.media?.primary : null);

  return media?.url ? resolveMediaUrl(media.url) : '';
};

export const parseContactHeroContent = (page) => {
  const section = getSection(page, 'hero');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  return {
    eyebrow: fields.eyebrow || '',
    title: fields.title,
    text: fields.text || '',
    image: getMediaUrl(section, 'hero-image'),
  };
};

export const parseContactFormContent = (page) => {
  const section = getSection(page, 'form');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  return {
    eyebrow: fields.eyebrow || '',
    title: fields.title,
    text: fields.text || '',
    buttonText: fields.buttonText || 'Send message',
    privacy: {
      text: fields.privacyText || 'I agree to the',
      linkText: fields.privacyLinkText || 'privacy policy',
      linkUrl: fields.privacyLinkUrl || '/privacy',
    },
    success: {
      eyebrow: fields.successEyebrow || 'Contact',
      title: fields.successTitle || 'Message sent',
      text: fields.successText || '',
    },
  };
};

export const parseContactSpeakContent = (page) => {
  const section = getSection(page, 'speak');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  const items = [];

  for (let index = 1; index <= 10; index += 1) {
    const label = fields[`item-${index}-label`];
    if (!label) {
      break;
    }

    items.push({
      label,
      value: fields[`item-${index}-value`] || '',
      href: fields[`item-${index}-href`] || '#',
      icon: getMediaUrl(section, `item-${index}-icon`),
    });
  }

  if (!fields.title || items.length === 0) {
    return null;
  }

  return {
    eyebrow: fields.eyebrow || '',
    title: fields.title,
    text: fields.text || '',
    items,
    image: getMediaUrl(section, 'feature-image'),
  };
};

export const parseContactPartnerContent = (page) => {
  const section = getSection(page, 'partner');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  return {
    title: fields.title,
    text: fields.text || '',
    cta: {
      text: fields.ctaText || '',
      url: fields.ctaUrl || '/partnership',
    },
  };
};
